var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1H513V343H0V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.44 137.693H0V206.093H223.44V342.893H291.84V206.093H515.28V137.693H291.84V0.892578H223.44V137.693Z",
    fill: "#EB000E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.44 62.4528L389.881 35.0928H412.681L408.12 62.4528L435.48 57.8928V80.6928L408.12 76.1328L412.681 103.493H389.881L394.44 76.1328L367.081 80.6928V57.8928L394.44 62.4528ZM104.881 62.4528L100.321 35.0928H123.121L118.561 62.4528L145.921 57.8928V80.6928L118.561 76.1328L123.121 103.493H100.321L104.881 76.1328L77.5205 80.6928V57.8928L104.881 62.4528ZM104.881 267.653L100.321 240.293H123.121L118.561 267.653L145.921 263.093V285.893L118.561 281.333L123.121 308.693H100.321L104.881 281.333L77.5205 285.893V263.093L104.881 267.653ZM394.44 267.653L389.881 240.293H412.681L408.12 267.653L435.48 263.093V285.893L408.12 281.333L412.681 308.693H389.881L394.44 281.333L367.081 285.893V263.093L394.44 267.653Z",
    fill: "#EB000E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.892578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/GE.6826305962d22ea6a51e53ed5f48f2fb.svg";
export { ForwardRef as ReactComponent };